import { FC } from 'react';

import View from './view';

const UserWorkSpaceDecommissionRequestPage: FC = () => {
  return <View />;
};
export default UserWorkSpaceDecommissionRequestPage;
